// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3211":"06c06595","9702":"abdd767f"}[chunkId] + ".chunk.css";
};